import { DataButton } from "@sellar-io/components";
import { TableInputContainer } from "../../../../components/tableInputContainer/TableInputContainer";
import { twMerge } from "tailwind-merge";
import {
  PayoutStatusFilterType,
  useSellarCreditFilterStore,
} from "../stores/SellarCreditFilterStore";

import { useShallow } from "zustand/react/shallow";
import { InputSelect, InputOption } from "@sellar-io/components";
import { useState } from "react";

export const SellarCreditsFilter = ({
  onDismiss,
  isMobile,
}: {
  onDismiss: () => void;
  isMobile?: boolean;
}) => {
  const state = useSellarCreditFilterStore(useShallow((state) => state));

  const [status, setStatus] = useState<PayoutStatusFilterType>(state.status);

  const filtersApplied = state.status !== "all";
  const disabled = status === "all";

  const onApply = (reset: boolean) => {
    if (reset) {
      useSellarCreditFilterStore.getState().reset();
    } else {
      useSellarCreditFilterStore.getState().setState({
        ...state,
        status,
      });
    }
    onDismiss();
  };

  return (
    <div>
      <div
        className={twMerge(
          "w-full",
          isMobile ? "px-4 pt-2" : "border-b border-zinc-300 p-4",
        )}
      >
        <span className="font-semibold">Filter Payouts</span>
      </div>
      <div className="w-full p-4">
        <div className="flex flex-col gap-3">
          {/* SellarCredit status filter */}
          <div className="flex w-full items-center justify-between gap-3">
            <div className="flex shrink-0">Status</div>
            <div className="w-[55%]">
              <TableInputContainer>
                <InputSelect
                  defaultValue={state.status}
                  onChange={(e: {
                    target: { value: string | PayoutStatusFilterType };
                  }) => {
                    const value = e.target.value;
                    const SellarCreditStatus = (
                      value.length ? value : null
                    ) as PayoutStatusFilterType;
                    setStatus(SellarCreditStatus);
                  }}
                  className="text-sm font-medium"
                >
                  <InputOption value={"all"}>All</InputOption>
                  <InputOption value={"draft"}>Draft</InputOption>
                  <InputOption value={"issued"}>Issued</InputOption>
                  <InputOption value={"payment_processing"}>
                    Payment processing
                  </InputOption>
                  <InputOption value={"paid"}>Paid</InputOption>
                  <InputOption value={"void"}>Void</InputOption>
                </InputSelect>
              </TableInputContainer>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full items-center gap-2 p-4">
        <DataButton
          onClick={() => onApply(false)}
          border={true}
          disabled={disabled}
        >
          {"Apply"}
        </DataButton>
        {!!filtersApplied && (
          <DataButton color="transparent" onClick={() => onApply(true)}>
            Clear all
          </DataButton>
        )}
      </div>
    </div>
  );
};
